module.exports = __webpack_public_path__ + "static/media/vehiculo.e4eb3494.jpg";